import { render, staticRenderFns } from "./CostQA.vue?vue&type=template&id=ccf53744&scoped=true&"
import script from "./CostQA.vue?vue&type=script&lang=js&"
export * from "./CostQA.vue?vue&type=script&lang=js&"
import style0 from "./CostQA.vue?vue&type=style&index=0&id=ccf53744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf53744",
  null
  
)

export default component.exports